module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-upload-preview"
  }, [_vm._l((_vm.currentList), function(item, index) {
    return _c('div', {
      key: item.url + index,
      staticClass: "s-upload-preview__item"
    }, [_c('img', {
      staticClass: "s-upload-preview__img",
      attrs: {
        "src": item.url,
        "alt": item.name
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "s-upload-preview__actions"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          return _vm.handlePreviewItem(item)
        }
      }
    }), _vm._v(" "), (!_vm.disabled) ? _c('i', {
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          return _vm.removeAt(index)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), (!_vm.isLimitReached) ? _c('div', {
    staticClass: "s-upload-preview__item"
  }, [_c('el-upload', _vm._b({
    ref: "upload",
    staticClass: "s-upload",
    scopedSlots: _vm._u([(_vm.$slots.trigger) ? {
      key: "trigger",
      fn: function() {
        return [_vm._t("trigger")]
      },
      proxy: true
    } : null, (_vm.$slots.tip) ? {
      key: "tip",
      fn: function() {
        return [_vm._t("tip")]
      },
      proxy: true
    } : null], null, true)
  }, 'el-upload', _vm.uploadProps, false), [(_vm.$slots.default) ? _vm._t("default") : _vm._e(), _vm._v(" "), (!_vm.$slots.default && _vm.isPictureCard) ? _c('i', {
    staticClass: "el-icon-plus"
  }) : _vm._e(), _vm._v(" "), (!_vm.$slots.default && !_vm.isPictureCard) ? _c('div', {
    staticClass: "s-upload-trigger__inner"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "s-upload-default__text"
  }, [(_vm.isDrag) ? [_vm._v("将文件拖到此处，或")] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "s-upload-default__link"
  }, [_vm._v("点击上传")])], 2)]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.previewDialog.name || '预览',
      "size": "large",
      "modal-append-to-body": false,
      "visible": _vm.previewDialog.visible,
      "custom-class": "s-upload-preview-dialog"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.previewDialog, "visible", $event)
      }
    }
  }, [_c('div', {
    staticClass: "s-upload-preview-body"
  }, [(_vm.previewDialog.url) ? _c('img', {
    attrs: {
      "src": _vm.previewDialog.url,
      "alt": _vm.previewDialog.name
    }
  }) : _vm._e()])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9319504c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SUpload.vue
// module id = 1103
// module chunks = 0